import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_CLIENT_API() + 'search/';
let URL_host = AppConfig.HOST_API();

export default {

    getPrzystankiWObuMiejscowosciach(idTr,data) {
        return axios({
            method: 'post',
            url: URL+'przystanki/'+idTr,
            data: JSON.stringify(data),
        })
    },

    getPrzystankiWObuSamychMiejscowosciach(data){
        return axios({
            method: 'post',
            url: URL+'przystanki/',
            data: JSON.stringify(data),
        })
    },

    getKursyMiedzyPrzystankamiWDanymCzasie(data) {
        return axios({
            method: 'post',
            url: URL+'rozklad',
            data: JSON.stringify(data),
        })
    },

    getZnizkiNaDanymOdcinku(data) {
        /*return axios({
            method: 'post',
            url: URL+'znizki',
            data: JSON.stringify(data),
        })*/
        return axios({
            method: 'post',
            url: URL_host+'znizki/jednorazowe/operator',
            data: JSON.stringify(data),
        })
    },

    getZnizkiMiesieczne(data) {
        return axios({
            method: 'post',
            url: URL+'znizki/miesieczne',
            data: JSON.stringify(data),
        })
    },

    getMiejscowosciNaTrasie(idTr) {
        return axios({
            method: 'get',
            url: URL + 'wariantTrasy/miejscowosci/'+idTr,
        });
    },

    getSzukajKursyPoTrasieDacieGodzinie(data){
        return axios({
            method: 'post',
            url: URL+'kursy',
            data: JSON.stringify(data),
        })
    },

    getSzukajPrzystankowZMiejscowosciamiPoTrasie(idTr){
        return axios({
            method: 'get',
            url: URL+'wariantTrasy/miejscowosciZPrzyst/'+idTr,
        })
    }


}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/biletyApi/ClientService.js